import React from "react";
import {
  Building2,
  ClipboardCheck,
  Workflow,
  HeartPulse,
  Handshake,
} from "lucide-react";

const steps = [
  {
    n: "01",
    icon: Building2,
    title: "Partnership Inquiry",
    body: "Tell us about your facility, provider group, healthcare organization, or support needs.",
  },
  {
    n: "02",
    icon: ClipboardCheck,
    title: "Review & Coordination",
    body: "Our team reviews your request and coordinates scheduling, operational details, and healthcare support requirements.",
  },
  {
    n: "03",
    icon: Workflow,
    title: "Service Planning",
    body: "We organize staffing availability, communication, scheduling logistics, and support expectations.",
  },
  {
    n: "04",
    icon: HeartPulse,
    title: "Healthcare Support Services",
    body: "T&J Clinical Solutions delivers responsive, professional healthcare support tailored to your organization.",
  },
  {
    n: "05",
    icon: Handshake,
    title: "Ongoing Partnership Support",
    body: "Maintain long-term communication, recurring services, and dependable healthcare coordination.",
  },
];

export const FacilityHowItWorks = () => (
  <section
    className="bg-white"
    style={{ borderTop: "1px solid #E2E8F0", borderBottom: "1px solid #E2E8F0" }}
    id="facility-how-it-works"
    data-testid="facility-how-it-works"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 sm:py-20">
      <div className="flex items-baseline gap-4 flex-wrap">
        <span
          className="font-display text-xs font-medium tracking-[0.22em]"
          style={{ color: "#D4AF37" }}
        >
          PARTNERSHIP PROCESS
        </span>
        <div>
          <h2
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight"
            style={{ color: "#0B2545" }}
          >
            How Facilities &amp; Providers Engage With Us
          </h2>
          <p
            className="mt-2 text-sm sm:text-base"
            style={{ color: "#475569" }}
          >
            From first inquiry to ongoing partnership — a clear path to dependable healthcare support.
          </p>
        </div>
      </div>
      <div className="tj-gold-rule mt-6" />

      <ol className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-5">
        {steps.map(({ n, icon: Icon, title, body }) => (
          <li
            key={n}
            className="relative rounded-xl border bg-white p-6 transition-transform hover:-translate-y-[2px]"
            style={{ borderColor: "#E2E8F0" }}
            data-testid={`facility-how-step-${n}`}
          >
            <div className="flex items-center gap-3">
              <span
                className="grid place-items-center h-11 w-11 rounded-lg shrink-0"
                style={{ background: "rgba(20, 184, 166, 0.10)" }}
              >
                <Icon
                  className="h-5 w-5"
                  style={{ color: "#0F766E" }}
                  strokeWidth={2.2}
                />
              </span>
              <span
                className="font-display text-2xl font-bold leading-none"
                style={{ color: "#D4AF37" }}
              >
                {n}
              </span>
            </div>
            <h3
              className="mt-5 font-display text-lg font-semibold"
              style={{ color: "#0B2545" }}
            >
              {title}
            </h3>
            <p
              className="mt-2 text-sm leading-relaxed"
              style={{ color: "#475569" }}
            >
              {body}
            </p>
          </li>
        ))}
      </ol>

      <p
        className="mt-10 text-center text-sm sm:text-base"
        style={{ color: "#475569" }}
        data-testid="facility-how-it-works-handoff"
      >
        Ready to start?{" "}
        <span style={{ color: "#0B2545", fontWeight: 600 }}>
          Share your details in the inquiry form below
        </span>{" "}
        and our partnerships team will reach out shortly.
      </p>
    </div>
  </section>
);

export default FacilityHowItWorks;
